import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, Validators, FormGroup, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { compareObjects } from '@helpers/compareObjects';
import { getErrorMessage } from '@helpers/getErrorMessage';
import { customerSupplierCategory, estadoFormulario, techConfModel } from '@modelos/enum/enums';
import { ConfigService } from '@servicios/config.service';
import { forkJoin, Subscription, take, tap } from 'rxjs';
import { dialogData } from '@interfaces/dialog-data.interfase';
import {
  AssayGroupAssayInput, AssayGroupInput, GetAssayGroup_assayGroup,
  GetAssayGroup_assayGroup_assayGroupAssays, GetAssayGroup_assayGroup_assayGroupAssays_assay,
  GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites, GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites_assayAnalite,
  GetAssays_assays, GetAssay_assay, GetAssay_assay_analites, GetCustomerSupplier_customersSuppliers, GetTechnicalConfigQuery_techConfigs
} from '@interfaces/operation-result-types';
import { valueTakenValidatorGQL } from '@validators/valueTakenValidator_GQL';
import { NotificacionesService } from '@servicios/notificaciones.service';
import { UserService } from '@servicios/user.service';
import { AssayAnaliteService } from '@servicios/assay/assayAnalite.service';
import { CustomerSupplierService } from '@servicios/customerSupplier/customer-supplier.service';
import { AssayService } from '@servicios/assay/assay.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { AssayGroupService } from '@servicios/assay/assayGroup.service';
import { ConfiguracionesTecnicasService } from '@servicios/configuracionesTecnicas.service';
import { multipleSelectFilter } from 'app/_sharedFuctions/shared-functions';
import { validationBio } from '../../../../_sharedFuctions/shared-functions';
import { FormTechConfig } from '@featuresModules/techConfigModule/generals/form-tech-config/form-tech-config.component';
import { modalConfig } from 'app/_pipes/modalConfig';
import { FormCustomerSupplierComponent } from '@featuresModules/comercial/customerSupplier/form-customer-supplier/form-customer-supplier.component';
import { LoadOptionsService } from '@servicios/load_options/load_options.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

export interface IAssaysSelected {
  assayName: string
  assayAnalites: IAssayAnalite[]
}

export interface IAssayAnalite {
  analiteName: string
  analize: boolean
  derived: boolean
  supplierId: string
}

export interface IAssayGroupFormData {
  groupReportName: boolean
  code: string
  name: string
  customers: GetCustomerSupplier_customersSuppliers[]
  active: boolean
  matrix: string
  v_?: number
  tenantId?: string
  index?: number
  assayGroupAssays: IAssayGroupAssayFormData[],
  matrixG_v2Ids?: (string | null)[] | null;
}

export interface IAssayGroupAssayFormData {
  id?: string
  assay: GetAssayGroup_assayGroup_assayGroupAssays_assay | GetAssay_assay
  assayAnalites: IAssayGroupAssayAnaliteFormData[]
  index?: number
}

export interface IAssayGroupAssayAnaliteFormData {
  id?: string
  index?: number
  analize: boolean
  assayAnalite: GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites_assayAnalite | GetAssay_assay_analites
}

export class _AssayGroup implements AssayGroupInput {
  code: string;
  name: string;
  customersIds?: string[];
  matrix?: string;
  active: boolean;
  assayGroupAssays?: AssayGroupAssayInput[];
  v_?: number;
  tenantId?: string;
  matrixG_v2Ids?: (string | null)[] | null;
  groupReportName: boolean;

  constructor(data: IAssayGroupFormData) {
    this.code = data.code
    this.name = data.name
    this.customersIds = data.customers ? data.customers.map(customer => customer.id) : undefined
    // Matriz principal: si vienen matrices v2, tomo la primera distinta de '0' (General).
    const selectedMatrices = (data.matrixG_v2Ids || []).filter(value => value && value !== '0') as string[];
    this.matrix = selectedMatrices.length ? selectedMatrices[0] : data.matrix
    this.active = data.active
    this.groupReportName = data.groupReportName
    this.assayGroupAssays = data.assayGroupAssays.map(assayGroupAssay => ({
      id: assayGroupAssay.id,
      assay: assayGroupAssay.assay.id,
      index: assayGroupAssay.index,
      assayAnalites: assayGroupAssay.assayAnalites.map(analite => ({
        id: analite.id,
        analize: analite.analize,
        assayAnalite: analite.assayAnalite.id,
        index: analite.index
      }))
    }))
    this.v_ = data.v_
    this.tenantId = data.tenantId
    //TODO: Ver si tiene sentido marcar la matriz como general.
    this.matrixG_v2Ids = data.matrixG_v2Ids?.filter(value => value !== '0')
  }


}

@Component({
  selector: 'app-form-assay-group',
  templateUrl: './form-assay-group.component.html',
  styleUrls: ['./form-assay-group.component.css'],
  providers: [],
  standalone: false
})
export class FormAssayGroupComponent implements OnInit {

  constructor(
    private fb: UntypedFormBuilder,
    private config: ConfigService,
    public ags: AssayGroupService,
    private us: UserService,
    @Inject(MAT_DIALOG_DATA) public data: dialogData,
    private dialogRef: MatDialogRef<FormAssayGroupComponent>,
    private css: CustomerSupplierService,
    private ns: NotificacionesService,
    public aas: AssayAnaliteService,
    private as: AssayService,
    private cts: ConfiguracionesTecnicasService,
    private dialog: MatDialog,
    private pipeNameComponent: modalConfig,
    private opts: LoadOptionsService,
    private dialogService: DialogService
  ) { }

  /* VARIABLES */
  //Formulario
  form: UntypedFormGroup;
  private initialValues: { [key: string]: any }
  language = this.config.selectedLanguage;
  onEditionData: GetAssayGroup_assayGroup;
  getErrorMessage = getErrorMessage;
  formControls: { [key: string]: AbstractControl; }
  assaySelect: MatSelect
  assaySelected: UntypedFormGroup
  assaySelectedIndex: number
  analitesAssaySelected: UntypedFormArray
  isBio = validationBio(this.config.appSettings?.general?.mode)

  //Subcripciones y datos externos
  valueChangesForm$ = new Subscription()
  subscriptions$ = new Subscription()

  //Componente
  formTitle: string
  isLoading = false
  isSaving = false
  isCheckingValidators = false
  spinnerMessage = this.language.loading
  dataSavedOnDB = false
  documentEditForm: NgForm
  draft = false
  isShowingDraft = false
  // FormControl for AssaySelect.
  assaySelectValue = new UntypedFormControl('')

  filterCustomersBy = new UntypedFormControl('')
  filteredCustomers: GetCustomerSupplier_customersSuppliers[] = []
  customers: GetCustomerSupplier_customersSuppliers[] = []
  customersOldSelectedValues: GetCustomerSupplier_customersSuppliers[] = []

  filterAssaysBy = new UntypedFormControl('')
  filteredAssays: GetAssays_assays[] = []
  assays: GetAssays_assays[] = []

  filterMatrixBy = new UntypedFormControl('')
  filteredMatrix: GetTechnicalConfigQuery_techConfigs[] = []
  matrix: GetTechnicalConfigQuery_techConfigs[] = []

  /* END VARIABLES */

  @ViewChild('documentEditForm') set content(content: NgForm) {
    if (content) { // initially setter gets called with undefined
      this.documentEditForm = content;
    }
  }

  /* LIFE CICLE HOOK`S */
  ngOnInit() {
    this.isLoading = true;

    if (this.data?.data) {
      this.ags.getOne({ id: this.data.data }).subscribe({
        next: res => this.initDialog(res.data.assayGroup),
        error: err => { this.isLoading = false; console.log(err) }
      })
    } else {
      this.initDialog()
    }
  }

  initDialog(_data?: GetAssayGroup_assayGroup) {
    switch (this.ags.modeForm) {
      case estadoFormulario.registroNuevo:
        this.formTitle = this.language.newAssayGroup;
        this.ags.draft ? this.onEditionData = this.ags.draft : null;
        break;
      case estadoFormulario.registroEdicion:
        this.formTitle = this.language.editAssayGroup;
        this.ags.draft && this.ags.draft?.id == this.data.data ? this.draft = true : this.draft = false;
        this.onEditionData = _data;
        this.dataSavedOnDB = true;
        break;
      case estadoFormulario.registroMostrar:
        this.formTitle = this.language.assayGroup;
        this.onEditionData = _data;
        break;
    }

    // Create form.
    this.form = this.fb.group({
      code: [],
      name: [],
      customers: [],
      matrix: [],
      active: [true],
      groupReportName: [false],
      assayGroupAssays: this.fb.array([]),
      v_: [],
      matrixG_v2Ids: []
    });

    //Initialize form variables.
    this.formControls = this.form.controls;

    // Load information to form on Edit or Draft.
    if (this.onEditionData) {
      this.patchFormValues(this.onEditionData);
      if (this.ags.modeForm == estadoFormulario.registroMostrar) this.form.disable();
    }
    // Save initial form values.
    this.initialValues = this.form.value

    //Set form´s validators.
    this.formControls.code.setValidators([Validators.required]);
    this.formControls.code.setAsyncValidators([valueTakenValidatorGQL('code', this.initialValues, this.ags, 'assayGroup', 'getOne', true)]);
    this.formControls.name.setValidators([Validators.required]);
    this.formControls.name.setAsyncValidators([valueTakenValidatorGQL('name', this.initialValues, this.ags, 'assayGroup', 'getOne', true)]);
    this.form.updateValueAndValidity({ emitEvent: false });

    //Subscripcions

    let customers$ = this.css.getAll(undefined, customerSupplierCategory.CUSTOMER).valueChanges.pipe(
      tap(({ data: { customersSuppliers } }) => { this.customers = customersSuppliers; this.filteredCustomers = this.customers })
      , take(1))
    let assays$ = this.as.getAll(false).valueChanges.pipe(
      tap(({ data: { assays } }) => { this.assays = assays; this.filteredAssays = this.assays })
      , take(1))
    let matrix$ = this.cts.getAll(techConfModel.matrix).valueChanges.pipe(
      tap(({ data: { techConfigs } }) => { this.matrix = techConfigs; this.filteredMatrix = this.matrix })
      , take(1))

    forkJoin([customers$, assays$, matrix$]).subscribe({
      next: () => {
        this.formSubscriptions()
        this.isLoading = false
      },
      error: err => { console.error(err), this.isLoading = false }
    })

  }

  ngOnDestroy() {
    this.valueChangesForm$.unsubscribe();
    this.subscriptions$.unsubscribe()
  }
  /* END LIFE CICLE HOOK´S */

  selectionChangeCustomerSupplier($event: MatSelectChange) {
    let finalValue = multipleSelectFilter($event.value, this.customersOldSelectedValues, this.filteredCustomers, 'id', this.onEditionData?.customers)
    this.customersOldSelectedValues = finalValue
    this.form.controls.customers.patchValue(finalValue, { emitEvent: false })
  }

  customersFilteredValues($event: GetCustomerSupplier_customersSuppliers[]) {
    this.filteredCustomers = $event
  }
  assaysFilteredValues($event: GetAssays_assays[]) {
    this.filteredAssays = $event
  }
  matrixFilteredValues($event: GetTechnicalConfigQuery_techConfigs[]) {
    this.filteredMatrix = $event
  }


  /* SUBSCRIPTIONS */
  formSubscriptions() {

    this.valueChangesForm$ = this.form.valueChanges.subscribe((value: GetAssay_assay) => {
      this.dataSavedOnDB = compareObjects(value, this.initialValues, { ignoreEmptyValues: true });
    });

    let assaySelectedValueSubs$ = this.assaySelectValue.valueChanges.subscribe({
      next: value => {
        if (value == '') return
        let index = this.sampleAssaysArray.value.findIndex(assay => assay.assay.name == value.name)
        if (index == -1) this.addAssay(value)
      }
    })

    let matrixSubs$ = this.form.controls.matrix.valueChanges.subscribe({
      next: value => {
        this.resetAssaysList()
        this.filteredAssays = this.filterAssaysByMatrix(this.assays)
        this.filterAssaysBy.updateValueAndValidity()
      }
    })

    let matrixG_V2Subs$ = this.form.controls.matrixG_v2Ids.valueChanges.subscribe({
      next: value => {
        this.resetAssaysList()
        this.filteredAssays = this.filterAssaysByMatrix(this.assays)
        this.filterAssaysBy.updateValueAndValidity()
      }
    })

    this.subscriptions$.add(assaySelectedValueSubs$)
    this.subscriptions$.add(matrixG_V2Subs$)
    this.subscriptions$.add(matrixSubs$)
  }

  /* END SUBSCRIPTIONS */

  /* FORM */
  patchFormValues(_value: GetAssayGroup_assayGroup) {
    this.form.controls.code.patchValue(_value.code)
    this.form.controls.customers.patchValue(_value.customers)
    this.form.controls.matrix.patchValue(_value.matrix?.id || "0")
    this.form.controls.name.patchValue(_value.name)
    this.form.controls.active.patchValue(_value.active)
    this.form.controls.v_.patchValue(_value.v_)
    this.form.controls.matrixG_v2Ids.patchValue(_value.matrixG_v2?.map(matrix => matrix.id));
    this.form.controls.groupReportName.patchValue(_value.groupReportName)

    _value.assayGroupAssays.map((assayGroupAssay) => {
      this.addAssay(assayGroupAssay)
    })
  }


  getMatrixControlName() {
    let controlName = "matrixG_v2Ids"
    return controlName
  }

  saveDraftData(formData: GetAssayGroup_assayGroup_assayGroupAssays) {
    this.ags.saveDraft(formData);
    this.dialogRef.close();
  }

  showDraft() {
    this.patchFormValues(this.ags.draft);
    this.isShowingDraft = true;
  }

  hideDraft() {
    this.patchFormValues(this.onEditionData);
    this.isShowingDraft = false;
  }
  /* END FORM */

  /* CRUD FUNCTIONS */
  save(formData: IAssayGroupFormData) {
    this.isSaving = true

    let data = new _AssayGroup(formData)


    if (this.ags.modeForm === estadoFormulario.registroNuevo) {
      this.spinnerMessage = this.language.saving + '...';
      this.ags.save(data)
        .subscribe({
          next: value => {
            this.ags.idSelected = value.data.createAssayGroup
            this.ns.emitMessage('Registro guardado')
            this.opts.updateOpts('assaysGroupsOptsSG', [])
            this.dialogRef.close(true)
          },
          error: err => this.localErrorHandler(err),
        }
        );
    } else {
      this.spinnerMessage = this.language.updating + '...';
      this.ags.update(this.onEditionData.id, data)
        .subscribe({
          next: () => {
            this.opts.updateOpts('assaysGroupsOptsSG', [])
            this.ns.emitMessage('Registro actualizado')
            this.dialogRef.close(true)
          },
          error: err => this.localErrorHandler(err)
        }
        )
    }
  };

  /* END CRUD FUNCTIONS */

  /* DIALOG */
  closeDialog() {
    this.draft = false;
    this.ags.clearDraft();
    this.ags.modeForm = estadoFormulario.registroNuevo;
    this.dialogRef.close();
  }
  /* END DIALOG */


  /* PERMISSIONS AND CONTROL VALUES */

  disbledSaveButton() {
    return false//(this.form.invalid || this.dataSavedOnDB)
  }

  showButtonShowDraftData() {
    return (this.draft &&
      !this.isShowingDraft &&
      this.ags.modeForm !== estadoFormulario.registroMostrar)
  }

  showButtonHideDraftData() {
    return (this.draft &&
      this.isShowingDraft &&
      this.ags.modeForm !== estadoFormulario.registroMostrar)
  }

  showButtonSaveDraftData() {
    return (this.ags.modeForm !== estadoFormulario.registroMostrar &&
      !this.dataSavedOnDB)
  }


  /* END PERMISSIONS AND CONTROL VALUES */

  /*OTHER FUNCTIONS */

  drop(event: CdkDragDrop<string[]>) {
    // Move the item in the array
    moveItemInArray(this.analitesAssaySelected.controls, event.previousIndex, event.currentIndex);

    // Update the index for each item in the array
    this.analitesAssaySelected.controls.forEach((control, index) => {
      const assayAnalite = { ...control.value, index }; // Create a new object with the updated index
      control.setValue(assayAnalite); // Set the new object back to the control
    });

    // Patch the updated values back to the form
    ((((this.form.controls.assayGroupAssays as FormArray).controls[this.assaySelectedIndex] as FormGroup).controls.assayAnalites as FormArray).patchValue(this.analitesAssaySelected.controls));
  }

  dropAssay(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.sampleAssaysArray.controls, event.previousIndex, event.currentIndex);
    this.sampleAssaysArray.controls.forEach((control, index) => {
      const assay = { ...control.value, index };
      control.setValue(assay);
    });
    console.log('this.sampleAssaysArray.controls', this.sampleAssaysArray.controls);
    (this.form.controls.assayGroupAssays as FormArray).patchValue(this.sampleAssaysArray.controls)
  }

  get sampleAssaysArray() {
    return this.form.controls.assayGroupAssays as UntypedFormArray
  }

  addAssay(data: GetAssayGroup_assayGroup_assayGroupAssays | GetAssay_assay) {
    if (!data) return
    this.sampleAssaysArray.push(this.newAssay(data))
  }


  newAssay(data: GetAssayGroup_assayGroup_assayGroupAssays | GetAssay_assay) {
    let assay = this.fb.group({
      id: data.__typename == 'AssayGroupAssay' ? data.id : undefined,
      // index: data.__typename == 'AssayGroupAssay' ? data.index : undefined,
      assayAnalites: this.fb.array([]),
      assay: (data as GetAssayGroup_assayGroup_assayGroupAssays).assay || (data as GetAssay_assay)
    })

    let analites = assay.controls.assayAnalites as UntypedFormArray

    let _analites
    if (data.hasOwnProperty('analites')) _analites = (data as GetAssay_assay).analites
    if (data.hasOwnProperty('assayAnalites')) _analites = (data as GetAssayGroup_assayGroup_assayGroupAssays).assayAnalites
    _analites.map(analite => {
      let new_analite = this.newAnalite(analite)
      if (new_analite) analites.push(new_analite)
    })
    return assay
  }

  newAnalite(analite: GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites | GetAssay_assay_analites) {
    if (analite.hasOwnProperty('active') && !(analite as GetAssay_assay_analites).active) return

    return this.fb.group({
      id: analite?.id,
      index: analite?.index,
      analize: [(analite as GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites).analize !== undefined ? (analite as GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites).analize : true],
      assayAnalite: (analite as GetAssayGroup_assayGroup_assayGroupAssays_assayAnalites).assayAnalite || (analite as GetAssay_assay_analites)
    })
  }

  showAnaliteList() {
    return this.analitesAssaySelected?.controls.length
  }

  assayClicked(i: number) {
    this.assaySelectedIndex = i
    this.assaySelected = (this.sampleAssaysArray.controls[i] as UntypedFormGroup)
    this.analitesAssaySelected = this.assaySelected.controls.assayAnalites as UntypedFormArray
  }

  removeAssay(index: number) {
    this.resetAssayListView()
    this.sampleAssaysArray.removeAt(index)
  }

  resetAssayListView() {
    this.analitesAssaySelected = undefined
    this.assaySelected = undefined
    this.assaySelectedIndex = undefined
  }

  resetAssayDerivedData() {
    this.sampleAssaysArray.controls.map(assay => {
      (assay as UntypedFormGroup).controls.derived.patchValue(false);
      (assay as UntypedFormGroup).controls.supplierId.patchValue(undefined)
    })
  }

  resetAssaysList() {
    this.analitesAssaySelected?.clear();
    (this.sampleAssaysArray as UntypedFormArray).clear()
  }

  compareWith(a: any, b: any) {
    return a.id === b.id
  }

  filterAssaysByMatrix(assays: GetAssay_assay[]) {
    return assays?.filter(assay => {
      if (!assay.matrix_v2?.length) return true
      let selectedMatrices: string[] = this.form.get('matrixG_v2Ids').value
      let assayMatricesValues = assay.matrix_v2.map(matrix => matrix.id)
      let result = assayMatricesValues.some(assayMatrix => selectedMatrices.some(selectedMatrix => selectedMatrix == assayMatrix))
      return result
    })
  }

  localErrorHandler(err: Error) {
    this.isSaving = false;
    this.spinnerMessage = 'Cargando...';
    let controlsKeys = Object.keys(this.form.controls)
    controlsKeys.map(control => this.form.controls[control].updateValueAndValidity())
    console.log(err);
  };



  setAssays() {
    return this.sampleAssaysArray.controls as FormGroup[]
  }

  setAnalites() {
    return this.analitesAssaySelected.controls as FormGroup[]
  }

  buttonConfig(ctrl, nameComponent, model, result_type) {
    this.cts.modeForm = estadoFormulario.registroNuevo;
    let data = undefined;
    const link = this.cts.filterLinks(model);
    const headerTitle = link?.form?.title?.new || 'Configuración Técnica';

    let dialogRef = this.dialogService.open(this.pipeNameComponent.transform(nameComponent), {
      header: headerTitle,
      width: '450px',
      position: 'right',
      modal: true,
      styleClass: 'sidebar-dialog',
      data: { data, model: model }
    });

    dialogRef.onClose.subscribe({
      next: async (data) => {
        let resp = await data;
        if (!resp) return;

        switch (ctrl) {
          case 'matrix':
          case 'matrixG_v2Ids':
            this.matrix = resp?.data?.[result_type];
            this.filteredMatrix = resp?.data?.[result_type];
            break;
          case 'customer':
            this.customers = resp?.data?.[result_type];
            this.filteredCustomers = resp?.data?.[result_type];
            break;

        }
        this.form.get(ctrl)?.updateValueAndValidity({ emitEvent: false })


      }
    })
  }

}
